import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService, type AuthUser } from './auth.service';

/**
 * Réserve la vue Manager aux encadrants (statut résolu par l'API depuis l'annuaire
 * Entra, cf. `AuthUser.isManager`). Ce guard n'est qu'un confort d'UI : l'endpoint
 * `control-activity-by-user` porte le même verrou côté API, il renvoie 403 sans ce
 * statut.
 *
 * - Pas manager (ou API antérieure à la fonctionnalité) → redirection /unauthorized
 * - Manager → accès accordé
 */
export const managerGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const decide = (user: AuthUser | null) =>
    user?.isManager === true ? true : router.createUrlTree(['/unauthorized']);

  // Le authGuard du parent a déjà rafraîchi la session : on lit le signal sans
  // refaire d'appel. Le fetch n'a lieu que si on arrive ici sans session en mémoire.
  const current = authService.user();
  return current ? decide(current) : authService.refreshSession().pipe(map(decide));
};
